import { useMemo } from "react";

import { isValue } from "@utilifeed/config";

import { KPICardGrid } from "../shared/KPICardGrid";
import type { KpiInput, PropertiesKpiLabels } from "./types";

type PropertiesKpiCardsProps = Readonly<{
  data: KpiInput;
  labels: PropertiesKpiLabels;
  loading: boolean;
}>;

export function PropertiesKpiCards({ data, labels, loading }: PropertiesKpiCardsProps) {
  const kpiData = useMemo(
    () => [
      {
        id: "kpi-cell-7d",
        title: labels.last7Days,
        value: isValue(data.averageIndoorTempLast7d)
          ? data.averageIndoorTempLast7d.toFixed(1)
          : "N/A",
        valueFormat: isValue(data.averageIndoorTempLast7d) ? `{value} °C` : "{value}",
        seriesData: data.series7d,
        seriesType: "area" as const,
      },
      {
        id: "kpi-cell-24h",
        title: labels.last24Hours,
        value: isValue(data.averageIndoorTempLast24h)
          ? data.averageIndoorTempLast24h.toFixed(1)
          : "N/A",
        valueFormat: isValue(data.averageIndoorTempLast24h) ? `{value} °C` : "{value}",
        seriesData: data.series24h,
        seriesType: "area" as const,
      },
    ],
    [data, labels]
  );

  return <KPICardGrid kpiData={kpiData} loading={loading} />;
}
